/**
 * Stable device fingerprint for trusted device (MFA skip) flow.
 * Stored in localStorage and sent as X-Device-Fingerprint on Auth API requests
 * so device trust works even when the evoly_device_fp cookie is blocked.
 */
/** Key used in localStorage; do not clear on logout so "Trust this device" persists. */
export const DEVICE_FINGERPRINT_STORAGE_KEY = "evoly_device_fp_id";
const STORAGE_KEY = DEVICE_FINGERPRINT_STORAGE_KEY;
const FINGERPRINT_LENGTH_BYTES = 32;

function generateFingerprint(): string {
  const bytes = new Uint8Array(FINGERPRINT_LENGTH_BYTES);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

/**
 * Returns a stable device fingerprint (64 hex chars). Creates and stores one if missing.
 */
export function getDeviceFingerprint(): string {
  try {
    let fp = localStorage.getItem(STORAGE_KEY);
    if (!fp || fp.length < 32) {
      fp = generateFingerprint();
      localStorage.setItem(STORAGE_KEY, fp);
    }
    return fp;
  } catch {
    return generateFingerprint();
  }
}
